import { useCallback, useEffect, useState } from 'react';

// State centralizado del modal de autenticación.
export function useAuthModalState() {
  const [open, setOpen] = useState(false);
  const [view, setView] = useState('login'); // login | register | magic | reset
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [redirectTo, setRedirectTo] = useState(null); // ruta a la que se debe ir tras login
  const [origin, setOrigin] = useState(null); // origen lógico: 'user-panel', 'header', etc.

  const openWith = useCallback((v='login', opts={}) => {
    setView(v);
    setOpen(true);
    setMessage('');
    setError('');
    if (opts.redirectTo !== undefined) setRedirectTo(opts.redirectTo || window.location.pathname || null);
    if (opts.origin !== undefined) setOrigin(opts.origin || null);
  }, []);
  const close = useCallback(()=>{ setOpen(false); setOrigin(null); setRedirectTo(null); }, []);

  useEffect(()=>{
    const handler = (e)=> { openWith(e.detail?.view || 'login', { redirectTo: e.detail?.redirectTo, origin: e.detail?.origin }); };
    window.addEventListener('auth:open', handler);
    return ()=> window.removeEventListener('auth:open', handler);
  },[openWith]);

  return { open, view, setView, openWith, close, loading, setLoading, message, setMessage, error, setError, redirectTo, origin };
}
